export const EShapeActionValueOpenType = wcardinal.ui.EShapeActionValueOpenType;